// @flow
// keyValue
export const SET_STATE = 'SET_STATE';
// ui
export const SET_UI_STATE = 'SET_UI_STATE';
export const SELECT_SIDEBAR_ITEMS = 'SELECT_SIDEBAR_ITEMS';
export const CLEAR_CALENDAR_SELECTION = 'CLEAR_CALENDAR_SELECTION';
export const SELECT_SIDEBAR_ITEM_REQUEST = 'SELECT_SIDEBAR_ITEM_REQUEST';
export const CLEAR_SIDEBAR_ITEMS = 'CLEAR_SIDEBAR_ITEMS';
export const CLEAR_ALL_SIDEBAR_ITEMS = 'CLEAR_ALL_SIDEBAR_ITEMS';
export const REFRESH_REQUEST = 'REFRESH_REQUEST';

// profile
export const FILL_PROFILE = 'FILL_PROFILE';

// resources
export const FETCH_RESOURCES_REQUEST = 'FETCH_RESOURCES_REQUEST';

// issues
export const LOAD_SELECT_ISSUES_REQUEST = 'LOAD_SELECT_ISSUES_REQUEST';

// filters
export const ADD_FILTER = 'ADD_FILTER';
export const SET_FILTER = 'SET_FILTER';
export const SET_FILTERS = 'SET_FILTERS';
export const REMOVE_FILTER = 'REMOVE_FILTER';
export const SET_FILTER_TYPE = 'SET_FILTER_TYPE';
export const LOAD_FILTER_OPTIONS_REQUEST = 'LOAD_FILTER_OPTIONS_REQUEST';
export const FETCH_FILTER_RESOURCES_BY_ID_REQUEST = 'FETCH_FILTER_RESOURCES_BY_ID_REQUEST';

// ui
export const ADD_FLAG = 'ui/ADD_FLAG';
export const DELETE_FLAG = 'ui/DELETE_FLAG';

// worklogs
export const SAVE_WORKLOG_REQUEST = 'worklogs/SAVE_WORKLOG_REQUEST';
export const DELETE_WORKLOG_REQUEST = 'worklogs/DELETE_WORKLOG_REQUEST';
